import * as React from "react";

import { cn } from "./utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full rounded-xl border-2 border-shire-bark/30 bg-white/90 px-4 py-3 font-body text-base shadow-inner backdrop-blur-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-base file:font-medium file:text-shire-dark placeholder:text-shire-bark/50 hover:border-shire-bark/50 focus:border-shire-sun focus:outline-none focus:ring-4 focus:ring-shire-sun/20 disabled:cursor-not-allowed disabled:opacity-50 sm:text-lg",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
